import type { Theme } from '@mui/material/styles'

export const makeStyles = (theme: Theme) => ({
	mainBox: {
		display: 'flex',
	},
	marginRightBox: {
		marginRight: '2rem',
	},
	recommendedSolutionsCard: {
		backgroundColor: '#FFF0F3',
		borderRadius: '18px',
		border: `1px solid ${theme.palette.primary.main}`,
		marginBottom: theme.spacing(2),
		padding: theme.spacing(2),
		cursor: 'pointer',
	},
	recommendedSolutionsCardSelected: {
		backgroundColor: '#f0c7cf',
		borderRadius: '18px',
		border: `1px solid ${theme.palette.primary.main}`,
		marginBottom: theme.spacing(2),
		padding: theme.spacing(2),
		cursor: 'pointer',
	},
	recommendedSolutionsPaper: {
		backgroundColor: 'white',
		color: 'black',
		height: '40.8rem',
		overflow: 'hidden',
		overflowY: 'scroll',
		padding: '2rem',
	},
	refreshButtonBox: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'end',
		alignItems: 'center',
		gap: '1rem',
	},
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		background: 'linear-gradient(0deg, #ff8a9f 60%, #f3123f 90%)',
		marginRight: '2rem',
	},
	solutionBox: {
		padding: theme.spacing(1),
		backgroundColor: '#FFF0F3',
	},
	solutionTextStyle: {
		color: '#000000DE',
		fontSize: '16px',
	},
	techniqueBox: {
		'white-space': 'pre-line',
	},
	typography: {
		opacity: 0.87,
		color: 'black',
	},
	typographyBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '2rem',
		flexGrow: '1',
	},
})
